<div class="app-mian-header  {{customClass}}">
  <div class="header-inner">
    <div class="menu-toggle" (click)="toggelSidebar()">
      <img src="assets/images/icons/minimize-sidebar-icon.svg" alt="">
    </div>
    <ng-container *ngIf="!forExtract; else forlayout">
      <div class="logo-mobile">
        <img [src]="logo">
      </div>
    </ng-container>
    <ng-template #forlayout>
      <div class="logo-forextract">
        <img [src]="logo">
      </div>
    </ng-template>
    <div class="header-actions">
      <a class="btn btn-lang" (click)="changeLanguage()">
        <img src="./assets/images/icons/language-icon.svg" alt="">
        {{ 'general.language' | translate }}
      </a>
    </div>
    <div class="header-part-right">
      <div class="elementor-widget-container">
        <div class="notification-btn dropdown-container" appDropDown>
          <span (click)="openNotificationPanel()" class="dropdown-toggler not-after">
            <span class="notification-count">{{ notificationsResult.unSeenNotificationsCount }}</span>
            <!-- <img src="./assets/images/icons/notifications-icon.svg"> -->
            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="21" viewBox="0 0 19 21" class="icon">
              <g id="Notifications" transform="translate(-227 -36)">
                <path id="notifications-icon"
                  d="M269.347,364.745l-1.974-1.955v-3.331a7.314,7.314,0,0,0-6.575-7.241v-1.449h-1.462v1.449a7.374,7.374,0,0,0-6.576,7.241v3.331l-1.973,1.955a.66.66,0,0,0-.219.507v2.172a.687.687,0,0,0,.731.725h5.115a3.653,3.653,0,0,0,7.306,0h5.115a.684.684,0,0,0,.73-.634.7.7,0,0,0,0-.091v-2.172A.656.656,0,0,0,269.347,364.745Zm-9.28,5.576a2.182,2.182,0,0,1-2.192-2.172h4.384a2.182,2.182,0,0,1-2.192,2.172ZM268.1,366.7H252.03v-1.158L254,363.586a.657.657,0,0,0,.219-.506v-3.621a5.845,5.845,0,0,1,11.69,0v3.621a.657.657,0,0,0,.219.506l1.973,1.956Z"
                  transform="translate(-23.566 -314.769)" fill="#5d6d7e" />
              </g>
            </svg>
          </span>
          <div class="notification-panel dropdown-inner-menu">
            <div class="dropdown-menu-header">
              <h3>{{ 'header.Notification' | translate }} </h3>
              <a *ngIf="hasPermission('Trainee')" [routerLink]="['/admin/notification-preference']" mat-button
                color="primary" class="btn_link_with_icon p-0 mx-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16">
                  <path id="Path_90774" data-name="Path 90774"
                    d="M166.588-864a1.61,1.61,0,0,1-1.163-.47,1.519,1.519,0,0,1-.484-1.13h3.294a1.519,1.519,0,0,1-.484,1.13A1.61,1.61,0,0,1,166.588-864Zm5.765-2.4H160.824a.809.809,0,0,1-.587-.23.763.763,0,0,1-.237-.57.763.763,0,0,1,.237-.57.809.809,0,0,1,.587-.23h.824v-5.6a4.6,4.6,0,0,1,1.029-2.95,4.764,4.764,0,0,1,2.676-1.69v-.56a1.141,1.141,0,0,1,.36-.85,1.209,1.209,0,0,1,.875-.35,1.209,1.209,0,0,1,.875.35,1.141,1.141,0,0,1,.36.85v.56a.467.467,0,0,1,.34.44.715.715,0,0,1-.237.6l-2.491,2.4a1.659,1.659,0,0,0-.36.52,1.506,1.506,0,0,0-.134.62v2.46a1.519,1.519,0,0,0,.484,1.13,1.61,1.61,0,0,0,1.163.47h2.532a1.747,1.747,0,0,0,.638-.12,1.579,1.579,0,0,0,.535-.34l.185-.18a.583.583,0,0,1,.669-.13.548.548,0,0,1,.381.55V-868h.824a.809.809,0,0,1,.587.23.763.763,0,0,1,.237.57.763.763,0,0,1-.237.57A.809.809,0,0,1,172.353-866.4Zm-5.765-5.6v-1.32a.883.883,0,0,1,.062-.32.609.609,0,0,1,.185-.26l4.3-4.16a1.179,1.179,0,0,1,.391-.25,1.269,1.269,0,0,1,.474-.09,1.233,1.233,0,0,1,.484.1,1.287,1.287,0,0,1,.4.26l.762.74a1.434,1.434,0,0,1,.257.39,1.1,1.1,0,0,1,.093.45,1.248,1.248,0,0,1-.093.47,1.118,1.118,0,0,1-.257.39l-4.282,4.16a.825.825,0,0,1-.278.18.874.874,0,0,1-.319.06h-1.359a.809.809,0,0,1-.587-.23A.763.763,0,0,1,166.588-872ZM172-875.68l.762-.78L172-877.2l-.782.76Z"
                    transform="translate(-160 880)" fill="#7D4393" />
                </svg>
                <span class="ml-1">
                  {{ 'general.preferences' | translate }}
                </span>
              </a>
            </div>

            <div>
              <div class="no-data text-center px-2 py-5" *ngIf="!notificationsList.length">
                {{ 'header.You have no notifications' | translate }}!
              </div>
              <div class="notification-list" *ngIf="notificationsList.length" infiniteScroll [scrollWindow]="false"
                [infiniteScrollDistance]="2" [infiniteScrollThrottle]="pageCount" (scrolled)="getNextPage()">
                <div *ngFor="let notif of notificationsList" [ngClass]="notif.isSeen ? '':'new'">
                  <ng-container [ngSwitch]="notif.notificationType">
                    <a *ngSwitchCase="notificationType.LAB_UPDATE"
                      (click)="getUnSeeNotifications(notif,['/admin/labProfile'])">
                      <p class="title">{{notif.text}}</p>
                      <span class="date">{{notif.date | date:'d MMM, y (h:mm a)'}}</span>
                    </a>
                    <a *ngSwitchCase="notificationType.NEW_TICKET"
                      (click)="getUnSeeNotifications(notif,['/admin/support-ticket'],{id:notif.objectId})">
                      <p class="title">{{notif.text}}</p>
                      <span class="date">{{notif.date | date:'d MMM, y (h:mm a)'}}</span>
                    </a>

                  </ng-container>
                </div>
              </div>
              <div *ngIf='notifLoading' class="dataLoading py-1">
                <mat-spinner class="m-auto" diameter="50"></mat-spinner>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="elementor-widget-container">
        <div *ngIf="currentUser" class="userAccount dropdown-container m-0" id="userAccountDrop" appDropDown>
          <div class="dropdown-toggler d-flex align-items-center">
            <div class="profile-image">
              <img *ngIf="currentUser.ImagePath" [src]="currentUser.ImagePath" (error)="currentUser.ImagePath = ''" />
              <span *ngIf="!currentUser.ImagePath" [innerHTML]="currentUser.FullName | shortName"></span>
            </div>
            <div class="user-name">
              <span class="mr-2"> {{ 'header.Hello' | translate }}, {{currentUser.FullName}}</span>
            </div>
          </div>

          <div class="custom-dropdown-menu dropdown-inner-menu">
            <ul>
              <li>
                <a [routerLink]="['myprofile']">
                  <svg width="14" height="17" viewBox="0 0 14 17">
                    <path id="my-profile-icon"
                      d="M7,8.5a12.35,12.35,0,0,1,5,1c1.3.6,2,1.4,2,2.4v1.7H0V11.9A2.954,2.954,0,0,1,2,9.5,12.35,12.35,0,0,1,7,8.5ZM2.6,15.3H4.4V17H2.6ZM7,0A3.74,3.74,0,0,1,9.5,1a2.965,2.965,0,0,1,1,2.4,2.965,2.965,0,0,1-1,2.4A3.74,3.74,0,0,1,7,6.8a3.317,3.317,0,0,1-2.5-1,3.1,3.1,0,0,1-1-2.4A2.965,2.965,0,0,1,4.5,1,3.74,3.74,0,0,1,7,0ZM6.1,15.3H7.8V17H6.1Zm3.5,0h1.8V17H9.6Z"
                      fill="#999999" />
                  </svg>{{ 'header.Edit-Profile' | translate }}
                </a>
              </li>
              <li hidden><a [routerLink]="['changepassword']">
                  <svg width="14" height="17" viewBox="0 0 14 17">
                    <path id="my-profile-icon"
                      d="M7,8.5a12.35,12.35,0,0,1,5,1c1.3.6,2,1.4,2,2.4v1.7H0V11.9A2.954,2.954,0,0,1,2,9.5,12.35,12.35,0,0,1,7,8.5ZM2.6,15.3H4.4V17H2.6ZM7,0A3.74,3.74,0,0,1,9.5,1a2.965,2.965,0,0,1,1,2.4,2.965,2.965,0,0,1-1,2.4A3.74,3.74,0,0,1,7,6.8a3.317,3.317,0,0,1-2.5-1,3.1,3.1,0,0,1-1-2.4A2.965,2.965,0,0,1,4.5,1,3.74,3.74,0,0,1,7,0ZM6.1,15.3H7.8V17H6.1Zm3.5,0h1.8V17H9.6Z"
                      fill="#999999" />
                  </svg>{{ 'auth.Update-password' | translate }}
                </a></li>
              <li>
                <a (click)="logout()">
                  <svg width="17.001" height="17.006" viewBox="0 0 17.001 17.006">
                    <path id="logout-icon"
                      d="M6223.19,12103h-13.4a1.815,1.815,0,0,1-1.8-1.808v-13.383a1.815,1.815,0,0,1,1.811-1.808h13.4a1.817,1.817,0,0,1,1.792,1.808v4.146l-1.659-1.559v-2.74h-13.687v13.575h13.687v-2.625l1.659-1.461v4.165a1.766,1.766,0,0,1-.529,1.267,1.69,1.69,0,0,1-1.123.43C6223.3,12103.006,6223.243,12103,6223.19,12103Zm-4.514-5.039,2.691-2.688h-9.562v-1.54h9.562l-2.691-2.691,1.167-1.169,4.52,4.629-4.52,4.629Z"
                      transform="translate(-6208 -12086)" fill="#999" />
                  </svg>{{ 'header.SignOut' | translate }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
